module.exports = __webpack_public_path__ + "img/mobile_banking_bbl.721e4ea3.png";